const zhCn = {
  general: {
    position: '职位',
    updateSuccess: '更新成功！',
    editProfileImg: '个人照片',
    editCoverImg: '封面图片',
    register: '注册',
    login: '登入',
    date: '日期',
    export: '汇出',
    or: '或',
    end: '结束',
    confirmEmail: '确认电子信箱',
    password: '密码',
    forgetPassword: '忘记密码？',
    changePassword: '更改密码',
    confirmPassword: '确认密码',
    knownAs: '昵称',
    oldPassword: '旧密码',
    newPassword: '新密码',
    minLength: '至少需要 {n} 个字元',
    unmatched: '{col}不相符。',
    chooseAnotherAccount: '使用另一个帐户登录',
    confirmNewPassword: '确认新密码',
    required: '必填项目',
    country: '国家',
    new: '新',
    username: '用户名',
    category: '类别'
  },
  editPhoto: '编辑照片',
  deletePhoto: '删除照片',
  changePhoto: '变更照片',
  savePhoto: '储存照片',
  livetour: '展间',
  country: {
    JP: '日本',
    KR: '韩国',
    HK: '港澳',
    SG: '新加坡',
    MY: '马来西亚',
    TH: '泰国',
    VN: '越南',
    ID: '印尼',
    PH: '菲律宾',
    EU: '欧洲',
    NA: '北美',
    NZ: '纽澳',
    TW: '台湾'
  },
  vrlounge: {
    lounge: '交流中心',
    networking: '名片夹',
    profile: '个人档案',
    peopleOnline: '线上使用者',
    totalVisitors: '全部访客',
    connect: '连结',
    waitConfirmed: '等待确认',
    isConfirmed: '已确认',
    confirm: '确认',
    reject: '婉拒',
    confirmReject: '确认拒绝 ?',
    hintReject: '此动作无法复原',
    thinkTwice: '我再想想',
    rejectInvitation: '婉拒邀请',
    connectSuccess: '连结成功',
    block: '封锁',
    visitor: '访客',
    exhibitor: '参展商',
    invitationTitle: '您可以添加注释以个性化您的邀请。',
    invitationPlaceholder: '您好！希望能跟您建立联系！ （最多不超过 1000个字元）',
    noTicketRecord: '无此票号 请购买票号',
    invalidTicket: '无效的票号',
    enterTicket: '请输入票号',
    sent: '寄出的',
    received: '收到的',
    connected: '已连结',
    agreeToContinue: '您必须同意条款和条件才能继续。',
    ticketUsed: '票券已被使用。',
    passwordRule: '密码必须包含8个字符，至少一个字母和一个数字。',
    cardExchange: '访客想与你交换名片，请确认是否接受或拒绝交换。',
    loginToAccount: '登入到您的帐号',
    keepLogin: '保持登录状态',
    cantLogin: '无法登录？ 点击',
    here: '这里',
    allRole: '全部身份',
    sortNameAtoZ: '姓名（A→Z）',
    sortNameZtoA: '姓名（Z→A）',
    onlineNewToOld: '最后登入时间（新到旧）',
    onlineOldToNew: '最后登入时间（旧到新）',
    exhibitorFirst: '参展商在前',
    visitorFirst: '访客在前',
    inviteTimeNewToOld: '邀请时间（新到旧）',
    inviteTimeOldToNew: '邀请时间（旧到新）',
    basicInfo: '基本资料',
    contact: '联系',
    contactInfo: '联络资料',
    state: '状态',
    sentRequest: '等待对方确认邀请',
    haveNotConfirmed: '您尚未确认邀请',
    message: '讯息',
    sendMessageTo: '传讯息给'
  },
  sort: '排序',
  filter: '筛选',
  test: '测试',
  apply: '套用',
  all: '全部',
  livingroom: '客厅',
  diningroom: '餐厅',
  kitchen: '厨房',
  bedroom: '卧室',
  study: '书房',
  bathroom: '浴室',
  toilet: '厕所',
  garden: '公共设施',
  garage: '车库/车位',
  outdoors: '建物外观',
  others: '其他',
  vrTooltip: 'VR模式仅限手机使用',
  vrInstructions: '请把<strong>手机</strong>放置于<strong>VR眼镜內</strong>。',
  send: '发送',
  scanQrCode: '扫描二维码，马上于您的手机上体验虚拟实境(VR)。',
  logOut: '退出',
  postAsAnonymous: '我想用访客身份留言。',
  loginGoogle: '以Google+身份登入',
  loginFacebook: '以Facebook账号登入（微信）',
  postComment: '留言',
  selectAction: '请选择',
  noBuilding: '很抱歉，此物件不存在。',
  browserNoSupport: '<h3>很抱歉，您的浏览器不支援。</h3><p>请下载并安装最新的浏览器版本，如<a href="https://www.google.com/chrome/browser/desktop">Chrome</a>、<a href="https://www.microsoft.com/en-us/download/internet-explorer-11-for-windows-7-details.aspx">IE11</a>或<a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>。</p>',
  webGlNoSupport: '<h3>很抱歉，您的浏览器或设备不支援 WebGL。请参访此<a href="https://www.istaging.com/webGLdetect/webGL.html" target="_blank">頁面</a></h3>',
  urlNoSupportIFrameError: '此连结已失效或该页面不接受外部连结嵌入',
  noPanoramas: '糟糕！此全景图并不存在',
  buildingNotFound: '<h3>糟糕！您点选的页面并不存在</h3><p>连结所存在的全景图可能已被移除</p><a href="https://www.istaging.com/zh-cn/livetour-gallery">前往其他LiveTour</a>',
  buildingNotInPropertyRedirect: '<h3>糟糕！此LiveTour已被移除</h3><p>即将为您导向此物件第一个项目......</p>',
  information: '介绍',
  panoSelect: '全景图',
  floorplan: '平面地图',
  qrCode: '二维码',
  music: '音乐',
  openMusic: '开启背景音乐',
  closeMusic: '关闭背景音乐',
  gyro: 'Gyro 模式',
  vrmode: 'VR 模式',
  fullscreen: '全萤幕检视',
  like: '赞',
  comment: '留言',
  propertyInfo: '建案介绍',
  buildingInfo: '场景介绍',
  buyNow: '现在购买',
  viewAtHome: 'AR 观看',
  learnMore: '了解更多',
  contactSupplier: '联系供应商',
  memo: '注记',
  location: '地点',
  promotionText: '现在就创建您的LiveTour',
  promotionLinkText: 'istaging.com',
  close: '关闭',
  addComment: '新增留言',
  share: '分享',
  leaveInfoContinue: '请留下您的信息以观看LiveTour',
  company: '公司',
  companyName: '公司名称',
  name: '姓名',
  firstName: '名',
  lastName: '姓',
  email: '电子信箱',
  phone: '电话',
  occupation: '职业',
  emailFormatInvalid: 'email格式不正确。',
  duplicateEmail: '重复的信箱',
  privacyPolicy: '隐私权政策',
  userTerms: '使用者条款',
  visitorLogin: '已经有帐号？',
  visitorAgreement1: '我们十分重视您的资料隐私权。勾选即表示您同意{company}的{termsTag}和{privacyTag}，​同时提供相关管理功能。',
  visitorAgreement2: '勾选即表示您授权{company}致电、发送电子邮件或简讯提供相关产品和服务信息。您可以通过{email}与我们联系来撤销此授权。',
  visitorAgreement: '我同意<a href="https://www.istaging.com/legal/terms_of_service" target="_blank">服务条款</a>和<a href="https://www.istaging.com/legal/privacy_policy" target="_blank"> 帐号私隐政策</a>',
  visitorLeaveDataReason: '请填写以下资讯，您会于您填写的 Email 信箱中收到专属认证连结，点击后您就能进入观看 LiveTour 了！',
  visitorAgreePolicy: '我同意该LiveTour 物件拥有者能够透过email或电话联络我',
  visitorEnterAccessKey: '请输入您email 收到的验证码。如果您还未收到, 请到垃圾信件匣检查',
  accessCode: '验证码',
  accessCodeError: '验证码错误',
  receiveEmailVerification: '请到您的email收取验证码',
  verify: '验证',
  back: '返回',
  welcomeToLiveTour: '欢迎来到 <strong>LiveTour</strong>，进行虚拟体验',
  resend: '重新发送',
  invalidAccessCode: '无效的验证码',
  resendCodeError: '寄送验证码失败',
  website: '网站',
  cardMore: '更多内容',
  clickNavigate: '点击前往',
  showMore: '看更多',
  searchTag: '搜寻标签',
  somethingWrong: '<h3>系统发生未知的问题</h3><a href="https://www.istaging.com/zh-cn/contact">回报问题</a>',
  GuidedTour: '线上带看',
  ClientWelcome: '欢迎使用',
  ClientFormHint: '点击”拨打“即表示我同意<a href="https://www.istaging.com/legal/terms_of_service" target="_blank" class="link-yellow">服务条款</a>、<a class ="link-yellow" href="https://www.istaging.com/legal/privacy_policy" target="_blank">隐私政策</a> 且专人能透过电话联系我',
  ClientFormWelcomeText: '填写下列资讯后按下拨打，<br>将由专人为您进行 <mark class="mark-yellow">线上带看</mark>，<br>建议您接上耳机麦克风，<br>并在良好的网路环境下进行。',
  ClientWelcomeNamePhoneHint: '请输入 姓名、电话',
  ClientWelcomeNameHint: '请输入 姓名',
  ClientWelcomePhoneHint: '请输入 电话或格式不正确',
  ClientWelcomeLanguage: '语言',
  ClientWelcomeLanguageDesc: '请选择线上带看使用的语言。',
  ClientWelcomeLanguageHint: '请选择 语言',
  FieldRequired: '*必填',
  ClientFormCallNow: '拨打',
  None: '暂无',
  Agent: '专人',
  RememberMe: '记住我',
  TheFieldIsRequired: '此栏位必填',
  IncorrectFormat: '格式有误',
  YouMustAgreeLicense: '您需要同意以上条款',
  Submit: '送出',
  BuildingNonPublicInfo: '此物件不公开',
  WebRTCNotSupportTitle: '浏览器不支援',
  WebRTCNotSupportDesc: '您目前使用的浏览器不支援此服务，您可透过按钮复制网址至 Chrome、Safari 或 Firefox 中开启',
  WebRTCNotSupportDesciOS: '您目前使用的浏览器不支援此服务，您可透过按钮复制网址至 Safari 开启',
  WebRTCNotSupportDescAndroid: '您目前使用的浏览器不支援此服务，您可透过按钮复制网址至 Chrome 或 Firefox 开启',
  WebRTCNotSupportCopyButton: '一键复制',
  Copied: '已复制',
  search: '搜索',
  searchContent: '搜索内容',
  noResult: '未找到結果',
  searchResult: '搜索结果',
  relatedResult: '相关推荐',
  scaleUp: '放大',
  scaleDown: '缩小',
  viewIn3D: '以 3D 模式观看',
  unableJoinMeeting: '无法加入会议',
  invalidMeetingId: '无效的会议编号',
  unableAccessMediaDevice: '浏览器无法存取您的摄影机/麦克风，请至浏览器媒体权限设定开启后重整页面。',
  connectingMeeting: '即将开启会议',
  meetingNotStartedYet: '会议尚未建立，无法加入',
  joinedMeeting: '已加入会议',
  joiningMeeting: '即将加入会议',
  repeatJoinWarning: '若再次加入，原先连线的页面将会中断连线',
  meetingIsOver: '会议已结束',
  startAnotherMeeting: '请至编辑器开启另一场会议',
  closeMeeting: '结束会议',
  joinMeeting: '参加会议',
  leaveMeeting: '离开会议',
  remainTime: '剩馀时间',
  meetingIsFull: '目前参与会议人数已达上限',
  connectionFail: '连线失败',
  unableConnectMeeting: '无法连上会议',
  joinMeetingFail: '加入会议失败',
  aboutEndMeeting: '您即将结束此次会议',
  aboutLeaveMeeting: '您即将离开此次会议',
  endedMeeting: '已结束此次会议',
  meetingRedirect: '将您导回至 LiveTour。',
  leftMeeting: '已离开此次会议',
  waitMeeting: '主持人暂离，待主持人连线后继续会议。若5分钟内未连线则将结束会议。',
  disconnectMeeting: '无法连线。请于五分钟内连线，并刷新页面以重回会议。',
  copyLink: '複製连结',
  copySuccess: '複製成功',
  confirm: '确定',
  cancel: '取消',
  IMServe: '即时客服',
  product: '产品',
  pilot: '语音导览',
  pilotBooking: '预约导览',
  pilotStop: '结束导览',
  pilotTours: '导览路线',
  pilotPopularTours: '热门导览路线',
  pilotInfluencerList: '导览员清单',
  pilotTourBy: '{influencer} 的所有导览路线',
  PilotDescription: '内容简介',
  PilotDetailedInformation: '重点展示内容',
  pilotSwitchTourNotice: '目前正在播放「{pilot1}」，是否要切换至「{pilot2}」？',
  pilotSameTourNotice: '目前正在播放「{pilot1}」，是否要从头开始？',
  pilotPlayerPopupButtonYes: '确定',
  pilotRecorderStart: '点击此开始录制',
  pilotRecorderStop: '点击此结束录制',
  pilotRecorderUploading: '上传中...',
  pilotRecorderUploadFailed: '上传失败',
  pilotRecorderPopupTitleNotice: '说明',
  pilotRecorderPopupTitleComplete: '录制完成',
  pilotRecorderPopupTitleError: '错误',
  pilotRecorderPopupTextNotice: '• 录制时间限制为10分钟。 <br>• 录制前请先允许系统存取麦克风使用权限。',
  pilotRecorderPopupTextComplete: '导览章节录制完成，请回到 VR Editor 观看与编辑',
  pilotRecorderPopupTextRelogin: '请重新登入',
  pilotRecorderPopupTextError: '请检查您浏览器中的麦克风权限',
  pilotRecorderPopupButtonOK: 'OK',
  pilotRecorderRemainTimeWarning: '10分钟录音时间即将结束，请尽快完成您的录制。',
  pilotTooltipTitle: '线按此处看导览路!',
  pilotTooltipConfirm: '我知道了！开始吧',
  pilotTooltipCancel: '略过导览',
  selectPilot: '选择导览',
  pilotInfluencer: '导览员',
  pilotChaptersTitle: '路线章节（选择以聆听）',
  pilotReadMoreBtnLabel: '阅读完整内容',
  pilotSelfBrowsingModeMessageTitle: '进入自行浏览模式',
  pilotSelfBrowsingModeMessageContent: '您可随时点击开启按钮回到导览模式。',
  pilotReplay: '重播',
  pilotPrevious: '上一个',
  pilotNext: '下一个',
  pilotPause: '暂停',
  pilotPlay: '播放',
  pilotTurnOnSelfBrowsingMode: '关闭导览模式',
  pilotTurnOffSelfBrowsingMode: '开启导览模式',
  uploadImage: '上传图片',
  productUnavailable: '这个商品已经下架了',
  booking: {
    calendar: '行事历',
    reserve: '预约',
    dateSelectTitle: '选择适合您的时间。',
    backToSelect: '选择另一时间',
    requiredField: '必须填写',
    timeRange: '时间范围',
    fieldMessage: '讯息',
    confirm: '确认预约',
    pleaseWait: '请稍候...',
    submitError: '送出请求时发生错误：',
    reserveSuccess: '预约成功',
    thanksUser: '谢谢',
    confirmingEmail: '您将很快收到一条确认会议详细信息的通知。',
    emailEmptyHint: '电子信箱为空'
  },
  favorites: {
    title: '我的最爱',
    add: '加入我的最爱',
    remove: '移除我的最爱',
    category: {
      marker: '产品',
      panorama: '展间',
      company: '公司',
      card: '名片'
    },
    table: {
      image: {
        company: 'Logo',
        marker: '产品图',
        card: '个人图片'
      },
      name: {
        company: '公司名称',
        marker: '产品名称',
        card: '姓名'
      },
      description: {
        company: '公司叙述',
        marker: '产品叙述'
      },
      type: '类型',
      // price: '价格',
      note: '备注',
      company: '公司',
      occupation: '职位',
      listEmpty: '尚无内容'
    },
    note: {
      empty: '输入一些备注...（最多 {n} 个字元）',
      saved: '已储存！'
    },
    pdf: {
      export: '汇出为 PDF',
      exporting: '汇出中...',
      note: '备注：',
      pager: '第 {page} 页，共 {total} 页'
    }
  },
  popup: {
    soundOn: '开启音效',
    soundOff: '关闭音效'
  },
  introAssets: {
    enter: '进入'
  },
  whiteList: {
    login: '登入帐号 · 尽情探索',
    error: '* 帐号或密码错误，请再试一次！',
    warnTitle: '认证失败',
    warnContent: '您所输入的用户名不存在于授权列表中，请重新输入或联系管理员。'
  },
  instantMessaging: {
    quickQA: '快速问答',
    mediaMessage: '分享了一份档案',
    locationMessage: '分享了位置资讯',
    startConversation: '在此展区与主办方开始对话吧！'
  },
  noSearchResult: '查无资料，请更改查询条件，再进行搜寻',
  tourring: {
    host: '主持人',
    noAnswer: '您的连络人暂时无法接听，',
    noPushId: '您的连络人目前不在线上，',
    busy: '您的连络人带看进行中，',
    response: '欢迎利用我们的日历功能进行预约，感谢您',
    goToReserve: '前往日历预约',
    dialing: '拨号中',
    dialingHint: '接通后，将引导至新分页',
    handupPhoneHint: '您的电话尚未接通，',
    handupPhoneHint2: '请确认是否挂断？'
  },
  otherFunctions: '其它功能',
  returnToFirstPanorama: '返回首张全景图',
  cookieBannerContent: '我们记录 cookie 资讯，以提供客制化内容，可优化您的使用体验，若继续阅览本网站内容，即表示您同意我们使用 cookies。更多关于隐私保护资讯，请阅览我们的',
  cookieBannerContentLinkAfter: '。',
  cookieBannerPolicyLinkText: '隐私权保护政策',
  cookieBannerButtonText: '同意'
}

export default zhCn
